import React from 'react'

const BetaRibbonContainer = ({ className, children }) => (
  <div className={`box ${className}`}>
    {children}
  </div>
)

export default BetaRibbonContainer
